module.exports = __webpack_public_path__ + "static/media/card.406ab6fd.png";